// Centralized test IDs for QA automation
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const AUTH = {
  loginForm: "login-form",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  registerForm: "register-form",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerWorkspace: "register-workspace-input",
  registerSubmit: "register-submit-button",
  logoutButton: "logout-button",
  goToLogin: "go-to-login-link",
  goToRegister: "go-to-register-link",
};

export const NAV = {
  shell: "app-shell",
  sidebar: "app-sidebar",
  dashboard: "nav-dashboard",
  contacts: "nav-contacts",
  lists: "nav-lists",
  segments: "nav-segments",
  campaigns: "nav-campaigns",
  templates: "nav-templates",
  verification: "nav-verification",
  aiTools: "nav-ai-tools",
  automation: "nav-automation",
  smtp: "nav-smtp",
  analytics: "nav-analytics",
  settings: "nav-settings",
  suppressions: "nav-suppressions",
  bounces: "nav-bounces",
  deliverability: "nav-deliverability",
};

export const DASH = {
  root: "dashboard-page",
  metricContacts: "metric-contacts",
  metricCampaigns: "metric-campaigns",
  metricOpenRate: "metric-open-rate",
  metricClickRate: "metric-click-rate",
};

export const CONTACTS = {
  root: "contacts-page",
  addBtn: "contact-add-button",
  importBtn: "contact-import-button",
  searchInput: "contacts-search-input",
  table: "contacts-table",
  saveBtn: "contact-save-button",
  rowEmailField: "contact-row-email",
  importTextarea: "contact-import-textarea",
  importSubmit: "contact-import-submit",
  wizardOpen: "contacts-wizard-open",
};

export const IMPORTS = {
  root: "imports-page",
  uploadInput: "imports-upload-input",
  uploadCard: "imports-upload-card",
  stepIndicator: "imports-step-indicator",
  nextBtn: "imports-next-button",
  backBtn: "imports-back-button",
  startBtn: "imports-start-button",
  mappingSelect: "imports-mapping-select",
  splitModeSelect: "imports-split-mode-select",
  splitFieldSelect: "imports-split-field-select",
  splitSizeInput: "imports-split-size-input",
  dedupeSelect: "imports-dedupe-select",
  listSelect: "imports-list-select",
  createListInput: "imports-create-list-input",
  progressBar: "imports-progress-bar",
  resultCard: "imports-result-card",
  errorsDownloadBtn: "imports-errors-download-button",
  newImportBtn: "imports-new-button",
};

export const LISTS = {
  root: "lists-page",
  addBtn: "list-add-button",
  saveBtn: "list-save-button",
  nameInput: "list-name-input",
  descInput: "list-description-input",
};

export const CAMPAIGNS = {
  root: "campaigns-page",
  newBtn: "campaign-new-button",
  builder: "campaign-builder",
  nameInput: "campaign-name-input",
  subjectInput: "campaign-subject-input",
  fromNameInput: "campaign-from-name-input",
  fromEmailInput: "campaign-from-email-input",
  saveBtn: "campaign-save-button",
  sendTestBtn: "campaign-send-test-button",
  sendNowBtn: "campaign-send-now-button",
  scheduleBtn: "campaign-schedule-button",
  duplicateBtn: "campaign-duplicate-button",
  saveAsTemplateBtn: "campaign-save-as-template-button",
  importHtmlBtn: "campaign-import-html-button",
  modeVisual: "campaign-mode-visual",
  modeCode: "campaign-mode-code",
  htmlEditor: "campaign-html-editor",
  blockHeading: "block-add-heading",
  blockSubheading: "block-add-subheading",
  blockText: "block-add-text",
  blockImage: "block-add-image",
  blockButton: "block-add-button",
  blockDivider: "block-add-divider",
  blockSpacer: "block-add-spacer",
  blockColumns: "block-add-columns",
  blockVideo: "block-add-video",
  blockSocial: "block-add-social",
  blockHtml: "block-add-html",
  blockFooter: "block-add-footer",
  blockLogo: "block-add-logo",
  blockQuote: "block-add-quote",
  blockList: "block-add-list",
  duplicateBlockBtn: "block-duplicate-button",
  spamCheckBtn: "campaign-spam-check-button",
  abTestToggle: "campaign-abtest-toggle",
  abVariantSubject: "campaign-ab-variant-subject",
  wizardTab: (id) => `campaign-wizard-tab-${id}`,
  wizardNext: "campaign-wizard-next",
  wizardBack: "campaign-wizard-back",
  wizardSendNow: "campaign-wizard-send-now",
  wizardScheduleSave: "campaign-wizard-schedule-save",
  scheduleModeImmediate: "campaign-schedule-mode-immediate",
  scheduleModeAt: "campaign-schedule-mode-at",
  scheduleModeSplit: "campaign-schedule-mode-split",
  splitScheduleDate: (lid) => `campaign-split-date-${lid}`,
  segSplitChip: (sid) => `audience-segment-split-${sid}`,
  segSplitDate: (sid) => `campaign-seg-split-date-${sid}`,
  segSplitAllToggle: "audience-segment-split-all",
};

export const SEGMENTS = {
  root: "segments-page",
  addBtn: "segment-add-button",
  nameInput: "segment-name-input",
  saveBtn: "segment-save-button",
  addRuleBtn: "segment-add-rule-button",
  previewBtn: "segment-preview-button",
};

export const AUTOMATIONS = {
  root: "automations-page",
  newBtn: "automation-new-button",
  builder: "automation-builder",
  nameInput: "automation-name-input",
  saveBtn: "automation-save-button",
  activateBtn: "automation-activate-button",
  addStepBtn: "automation-add-step-button",
};

export const TEMPLATES = {
  root: "templates-page",
  newBtn: "template-new-button",
  uploadBtn: "template-upload-button",
  uploadName: "template-upload-name",
  uploadSubject: "template-upload-subject",
  uploadHtml: "template-upload-html",
  uploadSubmit: "template-upload-submit",
  duplicateBtn: "template-duplicate-button",
  useBtn: "template-use-button",
};

export const VERIFY = {
  root: "verification-page",
  singleInput: "verify-single-input",
  singleSubmit: "verify-single-submit",
  singleResult: "verify-single-result",
  bulkTextarea: "verify-bulk-textarea",
  bulkSubmit: "verify-bulk-submit",
  resultsTable: "verify-results-table",
  listPicker: "verify-list-picker",
  listStart: "verify-list-start",
  listJob: "verify-list-job",
};

export const AI = {
  root: "ai-tools-page",
  subjectBriefInput: "ai-subject-brief-input",
  subjectSubmit: "ai-subject-submit",
  contentBriefInput: "ai-content-brief-input",
  contentSubmit: "ai-content-submit",
  spamSubject: "ai-spam-subject-input",
  spamBody: "ai-spam-body-input",
  spamSubmit: "ai-spam-submit",
};

export const SMTP = {
  root: "smtp-page",
  addBtn: "smtp-add-button",
  nameInput: "smtp-name-input",
  hostInput: "smtp-host-input",
  portInput: "smtp-port-input",
  usernameInput: "smtp-username-input",
  passwordInput: "smtp-password-input",
  fromEmailInput: "smtp-from-email-input",
  fromNameInput: "smtp-from-name-input",
  providerSelect: "smtp-provider-select",
  saveBtn: "smtp-save-button",
  testBtn: "smtp-test-button",
};

export const LANDING = {
  root: "landing-page",
  ctaSignup: "landing-signup-cta",
  ctaLogin: "landing-login-cta",
};

export const SUPPRESSIONS = {
  root: "suppressions-page",
  searchInput: "suppressions-search-input",
  reasonFilter: "suppressions-reason-filter",
  addBtn: "suppressions-add-button",
  importBtn: "suppressions-import-button",
  exportBtn: "suppressions-export-button",
  addEmailInput: "suppressions-add-email-input",
  addReasonSelect: "suppressions-add-reason-select",
  addNoteInput: "suppressions-add-note-input",
  addSubmit: "suppressions-add-submit",
  bulkTextarea: "suppressions-bulk-textarea",
  bulkSubmit: "suppressions-bulk-submit",
  importFile: "suppressions-import-file",
  importSubmit: "suppressions-import-submit",
  table: "suppressions-table",
  removeBtn: "suppressions-remove-button",
};

export const BOUNCES = {
  root: "bounces-page",
  totalCard: "bounces-total-card",
  byReasonCard: "bounces-by-reason-card",
  byDomainCard: "bounces-by-domain-card",
  byCampaignCard: "bounces-by-campaign-card",
};

export const DELIVERABILITY = {
  root: "deliverability-page",
  healthCard: "deliverability-health-card",
  healthScore: "deliverability-health-score",
  healthGrade: "deliverability-health-grade",
  warmupTab: "deliverability-warmup-tab",
  blacklistTab: "deliverability-blacklist-tab",
  healthTab: "deliverability-health-tab",
  warmupAddBtn: "warmup-add-button",
  warmupName: "warmup-name-input",
  warmupIp: "warmup-ip-input",
  warmupDays: "warmup-days-input",
  warmupPeak: "warmup-peak-input",
  warmupSubmit: "warmup-submit-button",
  warmupTable: "warmup-table",
  blacklistIp: "blacklist-ip-input",
  blacklistCheckBtn: "blacklist-check-button",
  blacklistResult: "blacklist-result",
  dashboardBadge: "dashboard-health-badge",
};

export const PREFERENCES = {
  root: "preferences-page",
  frequencySelect: "preferences-frequency-select",
  topicCheckbox: "preferences-topic-checkbox",
  saveBtn: "preferences-save-button",
  unsubscribeAllBtn: "preferences-unsubscribe-all-button",
  success: "preferences-success",
};
